module.exports = __webpack_public_path__ + "static/img/organilog-05.c76cf6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-05.png
// module id = 122
// module chunks = 0